import React, { useCallback } from 'react';
import { useObserver } from '../../../CodesThatsGottaGoSomewhereElse';
import { FontSizeIntervals } from '../../../platform/assets/FontFamilyInfo';
import { SliderWithInput } from '../../../ui/SliderWithInput';
import { Divide } from '../../dashboard/elements/LayoutElements';
import { PopoutWidget } from '../workspace/widgets/WidgetInterface';
import { ActionItem, ActionLayout, Box } from './../../../ui';

export const FontSizeWidget = ({ widget }: { widget: PopoutWidget }) => {

    const { value } = useObserver(widget);

    const onSelect = useCallback((next: number, close?: boolean) => {
        // This is hacky AF, I'm sorry:
        widget.update({
            open: !close,
            value: next,
        });
    }, [widget]);

    return <Box width="14" padding=".5">
        <SliderWithInput value={value} onChange={onSelect} min={1} max={512} />
        <Divide />

        <ActionLayout mode="grid:4" padding={1}>
            {FontSizeIntervals.map((x, i) => (
                <ActionItem
                    key={x.label}
                    title={x.label}
                    pressable
                    selected={value >= x.value && value < (FontSizeIntervals[i + 1]?.value ?? 99999999)}
                    style={{ padding: '.125rem' }}
                    onClick={() => onSelect(x.value)}>
                    {x.label}
                </ActionItem>
            ))}
        </ActionLayout>
    </Box>;
};
